import { createIcon } from "@chakra-ui/react";

export const Ribbon = createIcon({
  displayName: "Ribbon",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.063 1.296 11.559 0 9.056 1.296 6.27 1.72l-1.263 2.52L3 6.219 3.46 9 3 11.781l2.006 1.98 1.263 2.52 2.787.423L11.56 18l2.502-1.296 2.788-.423 1.262-2.52 2.007-1.98L19.659 9l.46-2.781-2.006-1.98-1.263-2.52-2.788-.423zM5.56 24v-6.31l3.027.46 2.973 1.54 2.972-1.54 3.028-.46V24l-6-1.5-6 1.5z"
    />,
  ],
  defaultProps: {
    "aria-label": "A ribbon"
  }
});

export default Ribbon;
